import { render, staticRenderFns } from "./Omega.vue?vue&type=template&id=5bb3bf82&scoped=true&"
import script from "./Omega.vue?vue&type=script&lang=js&"
export * from "./Omega.vue?vue&type=script&lang=js&"
import style0 from "./Omega.vue?vue&type=style&index=0&id=5bb3bf82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3bf82",
  null
  
)

export default component.exports